/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaPlus } from 'react-icons/fa';

import { useNavigate } from 'react-router-dom';
import { clearMemberData, deleteMember, fetchMember, selectMemberData, setMemberData } from '../../../store/slices/api/inner/MemberSlice';
import { selectSelectedMemberMember, setSelectedMember, toggleCommonDeleteModal } from '../../../store/slices/common';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import { NAVIGATION } from '../../../lib/navigation';
import Main from '../../../components/HOC/Main';
import Button from '../../../components/common/Button';
import TableAction from '../../../components/TableAction';
import CustomTable from '../../../components/common/CustomTable';

export const MemberPage = () => {
  const dispatch = useDispatch();
  const memberData = useSelector(selectMemberData);
  const selectedMember = useSelector(selectSelectedMemberMember)
  const navigate = useNavigate();

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchMember,
    setValueAction: setMemberData,
    clearValueActionOnError: clearMemberData,
    isForm: false,
    successMessage: false,
  });

  // delete start
  const openDeleteModal = (data) => {
    dispatch(setSelectedMember(data))
    dispatch(toggleCommonDeleteModal())
  }
  const cancelDeleteModal = () => {
    dispatch(setSelectedMember(null))
    dispatch(toggleCommonDeleteModal())
  }

  const afterAPICall = (res) => {
    fetchData()
    dispatch(toggleCommonDeleteModal())
  }

  const { handleSubmit: handleDelete } = useApiRequest({
    apiAction: deleteMember,
    isForm: false,
    afterAPICall,
  });
  // delete end

  const handleEdit = (data) => {
    navigate(NAVIGATION.INNER_NAVIGATION.MEMBER.UPDATE_MEMBER, { state: { memberData: data } });
  };

  const handleAdd = () => {
    dispatch(setSelectedMember(null));
    navigate(NAVIGATION.INNER_NAVIGATION.MEMBER.ADD_MEMBER)
  }
  

  const columns = useMemo(() => [

    {
      accessorKey: 'admin_name',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header:"name"
    },
    {
      accessorKey: 'admin_username',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header:"username"
    },
    {
      accessorKey: 'admin_user_type',
      cell: info => info.getValue().toUpperCase(),
      filterFn: 'includesStringSensitive',
      header:"User Type"
    },
    {
      id: 'actions',

      cell: info => info?.row?.original?.admin_user_type==='subadmin' && <TableAction handleEditButton={() => { handleEdit(info?.row?.original) }} handleDeleteButton={() => { openDeleteModal(info?.row?.original) }} />,
      header: () => <span>Actions</span>,
    },
  ], []);

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Main crumbs={[{ title: "admin users" }]} handleDelete={() => {handleDelete({ userToDelete: selectedMember.admin_id }) }} handleCandleDelete={cancelDeleteModal}>
      <CustomTable columns={columns} data={memberData} tableTop={<Button onClick={handleAdd} size='small'><FaPlus /> Add member</Button>} />
    </Main>
  );
};
